module.exports = __webpack_public_path__ + "assets/Chat.b526daa3e136b33fcd3a8fe4b792fa79.svg";